export var MaybeHasFee;
(function (MaybeHasFee) {
    MaybeHasFee["HAS_FEE"] = "HasFee";
    MaybeHasFee["NO_FEE"] = "NoFee";
})(MaybeHasFee || (MaybeHasFee = {}));
export var FareWarningLevel;
(function (FareWarningLevel) {
    FareWarningLevel["NORMAL"] = "Normal";
    FareWarningLevel["WARN"] = "Warn";
})(FareWarningLevel || (FareWarningLevel = {}));
export var LocalizedBaggageInfo;
(function (LocalizedBaggageInfo) {
    LocalizedBaggageInfo["UNKNOWN"] = "Unknown";
    LocalizedBaggageInfo["NOT_ALLOWED"] = "NotAllowed";
    LocalizedBaggageInfo["ALLOWED"] = "Allowed";
})(LocalizedBaggageInfo || (LocalizedBaggageInfo = {}));
//# sourceMappingURL=interfaces.js.map